import React, { useState, useEffect, useRef } from 'react';
import { db, Storage, auth } from '../firebase';
import { ref, uploadBytes, getDownloadURL} from 'firebase/storage';
import { setDoc, doc, collection,serverTimestamp, getDoc } from 'firebase/firestore';
import { useLocation, useNavigate } from 'react-router-dom';

import 'react-circular-progressbar/dist/styles.css';
import '../style/DesignUpload.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Canvas, Rect, Ellipse, Path, Image as FabricImage } from 'fabric';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Modal from '../components/Modal';
import {  FaTimes, FaTrash, FaUndo, FaShopify, FaSave } from 'react-icons/fa';



 const HoodiesProduct = 
 {
    name: 'Hoodie',
    title: 'hoodie',
    images: ['HoodieFront.jpg', 'HoodieBack.jpg', 'LeftSleeveHoodie.jpg', 'RightSleeveHoodie.jpg', 'LeftHood.jpg', 'RightHood.jpg'],
    description: 'Hoodie',
    fabric: '100% cotton with fleece',
    BASE_COST: 652,
    tax: 'tax',
    mockups: ['HoodieFront.jpg', 'HoodieBack.jpg', 'LeftSleeveHoodie.jpg', 'RightSleeveHoodie.jpg', 'LeftHood.jpg', 'RightHood.jpg'],
    texture: '21.png',
    GSM: '350 GSM',
    costStructure: {
  'DTG': {
    standard: {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
    },
    heavy: {
       logo: 72,
          LessthenA4: 108,
          A4less: 166,
          A4: 137,
          A3: 194.4,
          full: 220,
    }
  },
  'DTF': {
    standard: {
         logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
          full: 150,
    },
    heavy: {
      logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
          full: 150,
    }
  },
},
    clippingRects: {
    front: {
    DTF: { left: 530, top: 690, width: 1120, height: 900 },
    DTG: { left: 530, top: 690, width: 1120, height: 1400 }
  },
  back: {
    DTF: { left: 530, top: 690, width: 1120, height: 1400 },
    DTG: { left: 530, top: 690, width: 1120, height: 1400 }
  },
      leftsleeve: { left: 925, top: 1400, width: 360, height: 1100 },
      rightsleeve: { left: 925, top: 1500, width: 360, height: 1100 },
      lefthood: { left: 830, top: 710, width: 690, height: 630 },
      righthood: { left: 720, top: 710, width: 690, height: 630 }
    },
    print_method: ['DTG', 'DTF'],
    sizeChart: 'Hoodie-sizechart.jpg',
    sizes: ['S', 'M', 'L', 'XL', 'XXL']
  };


const HoodiesDesign = () => {
  const location = useLocation();
 const product = HoodiesProduct;
  const frontCanvasRef = useRef(null);
  const backCanvasRef = useRef(null);
  const fileInputRef = useRef(null);
  const formContainerRef = useRef(null);

  const [frontCanvas, setFrontCanvas] = useState(null);
  const [backCanvas, setBackCanvas] = useState(null);
  const [designImages, setDesignImages] = useState({ 
    frontDesignImage: null, 
    backDesignImage: null,   
    leftSleeveDesignImage: null,  
    rightSleeveDesignImage: null,
    leftHoodDesignImage: null,
    rightHoodDesignImage: null,
});

  const [isBlankProduct, setIsBlankProduct] = useState(false);
    // const [printProfile, setPrintProfile] = useState(null); 
    
    const [printProfile, setPrintProfile] = useState({ 
  front: null, 
  back: null,
});
    
    const printProfileRef = useRef(printProfile);
  const [selectedMethod, setSelectedMethod] = useState({ 
  front: null, 
  back: null, 
  leftSleeve: 'DTF',
  rightSleeve: 'DTF',  
  leftHood: 'DTF',
  rightHood: 'DTF'
});

  const [view, setView] = useState(0); 
  const [designName, setDesignName] = useState('');
  const [description, setDescription] = useState('');
  const [designFileNames, setDesignFileNames] = useState({ 
    
  frontDesignImage: '', 
  backDesignImage: '',   
  leftSleeveDesignImage: '',   
  rightSleeveDesignImage: '',
  leftHoodDesignImage: '',
  rightHoodDesignImage: '' ,
});

  const [frontDesignSize, setFrontDesignSize] = useState({ width: 0, height: 0 });
  const [backDesignSize, setBackDesignSize] = useState({ width: 0, height: 0 });
  const [frontDesignCost, setFrontDesignCost] = useState(0);
  const [backDesignCost, setBackDesignCost] = useState(0);

  const [leftSleeveDesignSize, setLeftSleeveDesignSize] = useState({ width: 0, height: 0 });
const [rightSleeveDesignSize, setRightSleeveDesignSize] = useState({ width: 0, height: 0 });
const [leftSleeveDesignCost, setLeftSleeveDesignCost] = useState(0);
const [rightSleeveDesignCost, setRightSleeveDesignCost] = useState(0);

  const [progress, setProgress] = useState(0);
  const [sellingPrice, setSellingPrice] = useState('');
  const [totalPrice, setTotalPrice] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [userShop, setUserShop] = useState(null);
  const productName = product.name; // or whatever key holds the product name
  const productGSM = product.GSM;
  const sizeChart = product.sizeChart;
  const printMethod = product.print_method;
  const sizes= product.sizes;
  const tax= product.tax;
  const baseCost= product.BASE_COST; 
  const [errors, setErrors] = useState({
    designName: '',
    description: '',
    sellingPrice: '',
    designImages: '',
    selectedMethod: '',
  });

  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); 
  const queryParams = new URLSearchParams(location.search);
  const shop = queryParams.get('shop'); 
  const navigate = useNavigate();
  const [availablePrintMethods, setAvailablePrintMethods] = useState([]);
  const [isSizeChartVisible, setIsSizeChartVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false); 

const leftSleeveCanvasRef = useRef(null);
const rightSleeveCanvasRef = useRef(null);
const [leftSleeveCanvas, setLeftSleeveCanvas] = useState(null);
const [rightSleeveCanvas, setRightSleeveCanvas] = useState(null);


const [leftHoodCanvas, setLeftHoodCanvas] = useState(null);
const [rightHoodCanvas, setRightHoodCanvas] = useState(null);
const leftHoodCanvasRef = useRef(null);
const rightHoodCanvasRef = useRef(null);
const [leftHoodDesignSize, setLeftHoodDesignSize] = useState({ width: 0, height: 0 });
const [rightHoodDesignSize, setRightHoodDesignSize] = useState({ width: 0, height: 0 });
const [leftHoodDesignCost, setLeftHoodDesignCost] = useState(0);
const [rightHoodDesignCost, setRightHoodDesignCost] = useState(0);



  const user = auth.currentUser;
  if (!user) {
    throw new Error("User not logged in");
  }


    const getClippingRect = (side, printMethod) => {
    if ((side === 'front' || side === 'back') && product.clippingRects[side][printMethod]) {
      return product.clippingRects[side][printMethod];
    }
    // Fallback to DTG if method not found, or return direct rect for sleeves/hood
    return product.clippingRects[side].DTG || product.clippingRects[side];
  };

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Add window resize handler to update corner sizes dynamically
  useEffect(() => {
    const handleResize = () => {
      // Force canvas re-render when window is resized to update corner sizes
      if (frontCanvas) {
        frontCanvas.renderAll();
      }
      if (backCanvas) {
        backCanvas.renderAll();
      }
      if (leftSleeveCanvas) {
        leftSleeveCanvas.renderAll();
      }
      if (rightSleeveCanvas) {
        rightSleeveCanvas.renderAll();
      }
      if (leftHoodCanvas) {
        leftHoodCanvas.renderAll();
      }
      if (rightHoodCanvas) {
        rightHoodCanvas.renderAll();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [frontCanvas, backCanvas, leftSleeveCanvas, rightSleeveCanvas, leftHoodCanvas, rightHoodCanvas]);

  // Cleanup body class on component unmount
  useEffect(() => {
    return () => {
      document.body.classList.remove('drawer-open');
    };
  }, []);




  useEffect(() => {
    const initCanvas = (ref) => {
      // Check if device is mobile
      const isMobile = window.innerWidth <= 768;
      
      return new Canvas(ref.current, {
        width: 2200,
        height: 2700,
        backgroundColor: "#fff",
        enableRetinaScaling: false,
        // Mobile-specific configurations
        allowTouchScrolling: true,
        selection: true,
        preserveObjectStacking: true,
        // Improve mobile interaction
        fireRightClick: true,
        stopContextMenu: false,
        // Better touch handling
        enablePointerEvents: true,
        // Larger touch targets for mobile - significantly increased for better mobile interaction
        cornerSize: isMobile ? 60 : 40,
        borderWidth: isMobile ? 20 : 15,
        // Mobile-friendly controls
        transparentCorners: false,
        cornerColor: '#007bff',
        borderColor: '#007bff',
        cornerStrokeColor: '#ffffff',
        borderStrokeColor: '#ffffff'
      });
    };


    const frontFabricCanvas = initCanvas(frontCanvasRef);
  const backFabricCanvas = initCanvas(backCanvasRef);
  const leftSleeveFabricCanvas = initCanvas(leftSleeveCanvasRef);
  const rightSleeveFabricCanvas = initCanvas(rightSleeveCanvasRef);
  const leftHoodFabricCanvas = initCanvas(leftHoodCanvasRef);
const rightHoodFabricCanvas = initCanvas(rightHoodCanvasRef);

  setFrontCanvas(frontFabricCanvas);
  setBackCanvas(backFabricCanvas);
  setLeftSleeveCanvas(leftSleeveFabricCanvas);
  setRightSleeveCanvas(rightSleeveFabricCanvas);
  setLeftHoodCanvas(leftHoodFabricCanvas);
  setRightHoodCanvas(rightHoodFabricCanvas);

  return () => {
    frontFabricCanvas.dispose();
    backFabricCanvas.dispose();
    leftSleeveFabricCanvas.dispose();
    rightSleeveFabricCanvas.dispose();
    leftHoodFabricCanvas.dispose();
    rightHoodFabricCanvas.dispose()
  };
}, []);


  useEffect(() => {
    if (product && product.print_method) {
        setAvailablePrintMethods(product.print_method);
    }
}, [product]);


useEffect(() => {
  printProfileRef.current = printProfile;
}, [printProfile]);

useEffect(() => {
  // Recalculate costs when print profile changes
  if (frontDesignSize.width > 0 && frontDesignSize.height > 0) {
    updateCostAndSize(frontDesignSize.width, frontDesignSize.height, 'front');
  }
  if (backDesignSize.width > 0 && backDesignSize.height > 0) {
    updateCostAndSize(backDesignSize.width, backDesignSize.height, 'back');
  }
}, [printProfile]);




// 8. Update loadMockupAndTexture useEffect
useEffect(() => {
  const loadMockupAndTexture = async (canvas, viewIndex) => {
    if (product) {
      try {
        const img = await FabricImage.fromURL(product.mockups[viewIndex]);
        canvas.set("backgroundImage", img);
        img.scaleToWidth(canvas.width);
        img.scaleToHeight(canvas.height);
        canvas.renderAll();

        let clippingRects;
        let rectId;
        let strokeColor;

        switch(viewIndex) {
        case 0: // Front
  const frontRect = getClippingRect('front', selectedMethod.front || 'DTG');
  clippingRects = [new Rect({
    left: frontRect.left,
    top: frontRect.top,
    width: frontRect.width,
    height: frontRect.height,
    selectable: false,
    evented: false,
    stroke: 'red',
    strokeWidth: 5,
    strokeDashArray: [4, 4],
    fill: 'rgba(0,0,0,0)',
    id: 'clippingRectFront',
    absolutePositioned: true,
  })];
  break;

case 1: // Back
  const backRect = getClippingRect('back', selectedMethod.back || 'DTG');
  clippingRects = [new Rect({
    left: backRect.left,
    top: backRect.top,
    width: backRect.width,
    height: backRect.height,
    selectable: false,
    evented: false,
    stroke: 'blue',
    strokeWidth: 5,
    strokeDashArray: [4, 4],
    fill: 'rgba(0,0,0,0)',
    id: 'clippingRectBack',
    absolutePositioned: true,
  })];
  break;
          case 2: // Left Sleeve
            clippingRects = [new Rect({
              left: product.clippingRects.leftsleeve.left,
              top: product.clippingRects.leftsleeve.top,
              width: product.clippingRects.leftsleeve.width,
              height: product.clippingRects.leftsleeve.height,
              selectable: false,
              evented: false,
              stroke: 'red',
              strokeWidth: 5,
              strokeDashArray: [4, 4],
              fill: 'rgba(0,0,0,0)',
              id: 'clippingRectLeftSleeve',
              absolutePositioned: true,
            })];
            break;
          case 3: // Right Sleeve
            clippingRects = [new Rect({
              left: product.clippingRects.rightsleeve.left,
              top: product.clippingRects.rightsleeve.top,
              width: product.clippingRects.rightsleeve.width,
              height: product.clippingRects.rightsleeve.height,
              selectable: false,
              evented: false,
              stroke: 'red',
              strokeWidth: 5,
              strokeDashArray: [4, 4],
              fill: 'rgba(0,0,0,0)',
              id: 'clippingRectRightSleeve',
              absolutePositioned: true,
            })];
            break;
//             case 4: // Left Hood
//   const leftHoodPath = new Path('M 500 250 L 580 240 Q 650 235 720 240 Q 790 245 860 260 Q 920 280 980 310 Q 1040 350 1080 400 Q 1110 440 1130 480 Q 1140 520 1135 560 Q 1130 600 1110 630 Q 1090 660 1060 680 L 1000 720 L 920 750 L 840 770 L 760 780 L 680 785 L 600 788 L 520 790 L 500 790 L 500 700 L 495 600 L 495 500 L 498 400 L 502 350 L 508 300 L 500 250 Z', {
//     left: product.clippingRects.lefthood.left,
//     top: product.clippingRects.lefthood.top,
//     selectable: false,
//     evented: false,
//     stroke: 'red',
//     strokeWidth: 5,
//     strokeDashArray: [4, 4],
//     fill: 'rgba(0,0,0,0)',
//     id: 'clippingPathLeftHood',
//     absolutePositioned: true,
//      angle: 90,
//   });
//   clippingRects = [leftHoodPath];
//   break;
// case 5: // Right Hood
// const rightHoodPath = new Path('M 700 500 A 300 180 0 0 1 1100 500 L 1100 600 L 700 600 Z', {
//     left: product.clippingRects.righthood.left,
//     top: product.clippingRects.righthood.top,
//     selectable: false,
//     evented: false,
//     stroke: 'red',
//     strokeWidth: 5,
//     strokeDashArray: [4, 4],
//     fill: 'rgba(0,0,0,0)',
//     id: 'clippingPathRightHood',
//     absolutePositioned: true,
//   });
//   clippingRects = [rightHoodPath];
//   break;

 case 4: // Left Sleeve
            clippingRects = [new Rect({
              left: product.clippingRects.lefthood.left,
              top: product.clippingRects.lefthood.top,
              width: product.clippingRects.lefthood.width,
              height: product.clippingRects.lefthood.height,
              selectable: false,
              evented: false,
              stroke: 'red',
              strokeWidth: 5,
              strokeDashArray: [4, 4],
              fill: 'rgba(0,0,0,0)',
              id: 'clippingRectLeftHood',
              absolutePositioned: true,
            })];
            break;
          case 5: // Right Sleeve
            clippingRects = [new Rect({
              left: product.clippingRects.righthood.left,
              top: product.clippingRects.righthood.top,
              width: product.clippingRects.righthood.width,
              height: product.clippingRects.righthood.height,
              selectable: false,
              evented: false,
              stroke: 'red',
              strokeWidth: 5,
              strokeDashArray: [4, 4],
              fill: 'rgba(0,0,0,0)',
              id: 'clippingRectRightHood',
              absolutePositioned: true,
            })];
            break;
             default:
        }

        clippingRects.forEach((rect) => canvas.add(rect));
        canvas.clipPaths = clippingRects;
        canvas.renderAll();
      } catch (error) {
        console.error("Error loading mockup image:", error);
      }
    }
  };

  if (frontCanvas) loadMockupAndTexture(frontCanvas, 0);
  if (backCanvas) loadMockupAndTexture(backCanvas, 1);
  if (leftSleeveCanvas) loadMockupAndTexture(leftSleeveCanvas, 2);
  if (rightSleeveCanvas) loadMockupAndTexture(rightSleeveCanvas, 3);
  if (leftHoodCanvas) loadMockupAndTexture(leftHoodCanvas, 4);
if (rightHoodCanvas) loadMockupAndTexture(rightHoodCanvas, 5);
}, [product, frontCanvas, backCanvas, leftSleeveCanvas, rightSleeveCanvas, leftHoodCanvas, rightHoodCanvas,selectedMethod]);


//  useEffect(() => {
//   const totalCost = frontDesignCost + backDesignCost + leftSleeveDesignCost + rightSleeveDesignCost;
//   const calculatedTotalPrice = product.BASE_COST + totalCost;
//   setTotalPrice(calculatedTotalPrice);
// }, [frontDesignCost, backDesignCost, leftSleeveDesignCost, rightSleeveDesignCost, product.BASE_COST]);

useEffect(() => {
  if (isBlankProduct) {
    // For blank products: base cost + ₹25
    setTotalPrice(product.BASE_COST + 25);
  } else {
    // For design products: base cost + design costs
    const totalCost = frontDesignCost + backDesignCost + leftSleeveDesignCost + rightSleeveDesignCost + leftHoodDesignCost + rightHoodDesignCost;
    const calculatedTotalPrice = product.BASE_COST + totalCost;
    setTotalPrice(calculatedTotalPrice);
  }
}, [frontDesignCost, backDesignCost, leftSleeveDesignCost, rightSleeveDesignCost, leftHoodDesignCost, rightHoodDesignCost, product.BASE_COST, isBlankProduct]);

  const handleSellingPriceChange = (e) => {
    setSellingPrice(e.target.value);
  };

const handleBlankProductToggle = (checked) => {
  setIsBlankProduct(checked);
  
  if (checked) {
    // Clear all design-related data
    setDesignImages({ 
      frontDesignImage: null, 
      backDesignImage: null,   
      leftSleeveDesignImage: null,
      rightSleeveDesignImage: null 
    });
    setDesignFileNames({ 
      frontDesignImage: '', 
      backDesignImage: '',   
      leftSleeveDesignImage: '',
      rightSleeveDesignImage: '' 
    });
    setSelectedMethod({ 
      front: null, 
      back: null, 
      leftSleeve: null,
      rightSleeve: null  
    });
    setFrontDesignSize({ width: 0, height: 0 });
    setBackDesignSize({ width: 0, height: 0 });
    setLeftSleeveDesignSize({ width: 0, height: 0 });
    setRightSleeveDesignSize({ width: 0, height: 0 });
    setFrontDesignCost(0);
    setBackDesignCost(0);
    setLeftSleeveDesignCost(0);
    setRightSleeveDesignCost(0);
    
    // Clear all canvases
    [frontCanvas, backCanvas, leftSleeveCanvas, rightSleeveCanvas].forEach(canvas => {
      if (canvas) {
        const objects = canvas.getObjects().filter(obj => obj.type === 'image' || obj.isDesignImage);
        objects.forEach(obj => canvas.remove(obj));
        canvas.renderAll();
      }
    });
    
    // Clear file input
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  }
};

const updateCostAndSize = (widthUnits, heightUnits, side) => {
  const area = widthUnits * heightUnits;
  let newCost = 0;

  if (widthUnits > 0 && heightUnits > 0) {
    let currentMethod;
    
    switch(side) {
      case 'front':
        currentMethod = selectedMethod.front;
        break;
      case 'back':
        currentMethod = selectedMethod.back;
        break;
      case 'leftSleeve':
        currentMethod = selectedMethod.leftSleeve;
        break;
      case 'rightSleeve':
        currentMethod = selectedMethod.rightSleeve;
        break;
            case 'leftHood':
        currentMethod = selectedMethod.leftHood;
        break;
              case 'rightHood':
        currentMethod = selectedMethod.rightHood;
        break;
        default:
    }

if (currentMethod && product.costStructure[currentMethod]) {
      // const selectedCostStructure = product.costStructure[currentMethod][printProfileRef.current];


      const currentPrintProfile = printProfileRef.current[side] || 'standard';
const selectedCostStructure = product.costStructure[currentMethod][currentPrintProfile];


      if (productName === "Black Baby Tee" || productName === "White Baby Tee") {
        if (area <= 25) {
          newCost = selectedCostStructure.logo || 0;
        } else if (area <= 60) {
          newCost = selectedCostStructure.LessthenA4 || 0;
        } else if (area <= 97.11) {
          newCost = selectedCostStructure.A4 || 0;
        } else if (area <= 120) {
          newCost = selectedCostStructure.full || 0;
        } else {
          newCost = selectedCostStructure.full || 0;
        }
      } else {
        if (area <= 25) {
          newCost = selectedCostStructure.logo || 0;
        } else if (area <= 63) {
          newCost = selectedCostStructure.LessthenA4 || 0;
        } else if (area <= 97.11) {
          newCost = selectedCostStructure.A4 || 0;
        } else if (area <= 144) {
          newCost = selectedCostStructure.A4less || 0;
        } else if (area <= 224) {
          newCost = selectedCostStructure.A3 || 0;
        } else if (area <= 320) {
          newCost = selectedCostStructure.full || 0;
        } else {
          newCost = selectedCostStructure.full || 0;
        }
      }
    }
  }

  switch(side) {
    case 'front':
      setFrontDesignSize({ width: widthUnits, height: heightUnits });
      setFrontDesignCost(newCost);
      break;
    case 'back':
      setBackDesignSize({ width: widthUnits, height: heightUnits });
      setBackDesignCost(newCost);
      break;
    case 'leftSleeve':
      setLeftSleeveDesignSize({ width: widthUnits, height: heightUnits });
      setLeftSleeveDesignCost(newCost);
      break;
    case 'rightSleeve':
      setRightSleeveDesignSize({ width: widthUnits, height: heightUnits });
      setRightSleeveDesignCost(newCost);
      break;
    case 'leftHood':
      setLeftHoodDesignSize({ width: widthUnits, height: heightUnits });
      setLeftHoodDesignCost(newCost);
      break;
    case 'rightHood':
      setRightHoodDesignSize({ width: widthUnits, height: heightUnits });
      setRightHoodDesignCost(newCost);
  break;
       default:
  }

  return newCost;
};


// const refreshClippingRects = () => {
//   if (frontCanvas) {
//     // Remove old clipping rects from front canvas
//     const frontObjects = frontCanvas.getObjects().filter(obj => obj.id && obj.id.includes('clippingRect'));
//     frontObjects.forEach(obj => frontCanvas.remove(obj));
    
//     // Add new clipping rect based on current method
//     const frontRect = getClippingRect('front', selectedMethod.front || 'DTG');
//     const newFrontClippingRect = new Rect({
//       left: frontRect.left,
//       top: frontRect.top,
//       width: frontRect.width,
//       height: frontRect.height,
//       selectable: false,
//       evented: false,
//       stroke: 'red',
//       strokeWidth: 5,
//       strokeDashArray: [4, 4],
//       fill: 'rgba(0,0,0,0)',
//       id: 'clippingRectFront',
//       absolutePositioned: true,
//     });
//     frontCanvas.add(newFrontClippingRect);
//     frontCanvas.renderAll();
//   }
  
//   if (backCanvas) {
//     // Remove old clipping rects from back canvas
//     const backObjects = backCanvas.getObjects().filter(obj => obj.id && obj.id.includes('clippingRect'));
//     backObjects.forEach(obj => backCanvas.remove(obj));
    
//     // Add new clipping rect based on current method
//     const backRect = getClippingRect('back', selectedMethod.back || 'DTG');
//     const newBackClippingRect = new Rect({
//       left: backRect.left,
//       top: backRect.top,
//       width: backRect.width,
//       height: backRect.height,
//       selectable: false,
//       evented: false,
//       stroke: 'blue',
//       strokeWidth: 5,
//       strokeDashArray: [4, 4],
//       fill: 'rgba(0,0,0,0)',
//       id: 'clippingRectBack',
//       absolutePositioned: true,
//     });
//     backCanvas.add(newBackClippingRect);
//     backCanvas.renderAll();
//   }
// };

const refreshClippingRects = (frontMethod = null, backMethod = null) => {
  if (frontCanvas) {
    // Remove old clipping rects from front canvas
    const frontObjects = frontCanvas.getObjects().filter(obj => obj.id && obj.id.includes('clippingRect'));
    frontObjects.forEach(obj => frontCanvas.remove(obj));
    
    // Use passed method or current state
    const methodToUse = frontMethod || selectedMethod.front || 'DTG';
    const frontRect = getClippingRect('front', methodToUse);
    const newFrontClippingRect = new Rect({
      left: frontRect.left,
      top: frontRect.top,
      width: frontRect.width,
      height: frontRect.height,
      selectable: false,
      evented: false,
      stroke: 'red',
      strokeWidth: 5,
      strokeDashArray: [4, 4],
      fill: 'rgba(0,0,0,0)',
      id: 'clippingRectFront',
      absolutePositioned: true,
    });
    frontCanvas.add(newFrontClippingRect);
    frontCanvas.renderAll();
  }
  
  if (backCanvas) {
    // Remove old clipping rects from back canvas
    const backObjects = backCanvas.getObjects().filter(obj => obj.id && obj.id.includes('clippingRect'));
    backObjects.forEach(obj => backCanvas.remove(obj));
    
    // Use passed method or current state
    const methodToUse = backMethod || selectedMethod.back || 'DTG';
    const backRect = getClippingRect('back', methodToUse);
    const newBackClippingRect = new Rect({
      left: backRect.left,
      top: backRect.top,
      width: backRect.width,
      height: backRect.height,
      selectable: false,
      evented: false,
      stroke: 'blue',
      strokeWidth: 5,
      strokeDashArray: [4, 4],
      fill: 'rgba(0,0,0,0)',
      id: 'clippingRectBack',
      absolutePositioned: true,
    });
    backCanvas.add(newBackClippingRect);
    backCanvas.renderAll();
  }
};


// const handlePrintMethodChange = (printMethod) => {
//   let currentSide;
//   let activeCanvas;
  
//   switch(view) {
//     case 0:
//       currentSide = 'front';
//       activeCanvas = frontCanvas;
//       break;
//     case 1:
//       currentSide = 'back';
//       activeCanvas = backCanvas;
//       break;
//     case 2:
//       currentSide = 'leftSleeve';
//       activeCanvas = leftSleeveCanvas;
//       break;
//     case 3:
//       currentSide = 'rightSleeve';
//       activeCanvas = rightSleeveCanvas;
//       break;
//     case 4:
//   currentSide = 'leftHood';
//   activeCanvas = leftHoodCanvas;
//   break;
//   case 5:
//   currentSide = 'rightHood';
//   activeCanvas = rightHoodCanvas;
//   break;
//        default:
//   }
  
//   const objects = activeCanvas.getObjects().filter(obj => obj.type === 'image');
//   objects.forEach(obj => activeCanvas.remove(obj));
//   activeCanvas.renderAll();
  
//   // Reset design images and costs based on current side
//   switch(currentSide) {
//     case 'front':
//       setDesignImages(prev => ({ ...prev, frontDesignImage: null, frontDesignImageUrl: null }));
//       setDesignFileNames(prev => ({ ...prev, frontDesignImage: '' }));
//       setFrontDesignSize({ width: 0, height: 0 });
//       setFrontDesignCost(0);
//       break;
//     case 'back':
//       setDesignImages(prev => ({ ...prev, backDesignImage: null, backDesignImageUrl: null }));
//       setDesignFileNames(prev => ({ ...prev, backDesignImage: '' }));
//       setBackDesignSize({ width: 0, height: 0 });
//       setBackDesignCost(0);
//       break;
//     case 'leftSleeve':
//       setDesignImages(prev => ({ ...prev, leftSleeveDesignImage: null, leftSleeveDesignImageUrl: null }));
//       setDesignFileNames(prev => ({ ...prev, leftSleeveDesignImage: '' }));
//       setLeftSleeveDesignSize({ width: 0, height: 0 });
//       setLeftSleeveDesignCost(0);
//       break;
//     case 'rightSleeve':
//       setDesignImages(prev => ({ ...prev, rightSleeveDesignImage: null, rightSleeveDesignImageUrl: null }));
//       setDesignFileNames(prev => ({ ...prev, rightSleeveDesignImage: '' }));
//       setRightSleeveDesignSize({ width: 0, height: 0 });
//       setRightSleeveDesignCost(0);
//       break;
//     case 'leftHood':
//   setDesignImages(prev => ({ ...prev, leftHoodDesignImage: null, leftHoodDesignImageUrl: null }));
//   setDesignFileNames(prev => ({ ...prev, leftHoodDesignImage: '' }));
//   setLeftHoodDesignSize({ width: 0, height: 0 });
//   setLeftHoodDesignCost(0);
//   break;
// case 'rightHood':
//   setDesignImages(prev => ({ ...prev, rightHoodDesignImage: null, rightHoodDesignImageUrl: null }));
//   setDesignFileNames(prev => ({ ...prev, rightHoodDesignImage: '' }));
//   setRightHoodDesignSize({ width: 0, height: 0 });
//   setRightHoodDesignCost(0);
//   break;
//       default:
//   }

//   if (fileInputRef.current) {
//     fileInputRef.current.value = '';
//   }
  
//   setSelectedMethod(prev => ({
//     ...prev,
//     [currentSide]: printMethod
//   }));


//     setTimeout(() => {
//     refreshClippingRects();
//   }, 100);
// };

const handlePrintMethodChange = (printMethod) => {
  let currentSide;
  let activeCanvas;
  
  switch(view) {
    case 0:
      currentSide = 'front';
      activeCanvas = frontCanvas;
      break;
    case 1:
      currentSide = 'back';
      activeCanvas = backCanvas;
      break;
    case 2:
      currentSide = 'leftSleeve';
      activeCanvas = leftSleeveCanvas;
      break;
    case 3:
      currentSide = 'rightSleeve';
      activeCanvas = rightSleeveCanvas;
      break;
    case 4:
      currentSide = 'leftHood';
      activeCanvas = leftHoodCanvas;
      break;
    case 5:
      currentSide = 'rightHood';
      activeCanvas = rightHoodCanvas;
      break;
    default:
  }
  
  const objects = activeCanvas.getObjects().filter(obj => obj.type === 'image');
  objects.forEach(obj => activeCanvas.remove(obj));
  activeCanvas.renderAll();
  
  // Reset design images and costs based on current side
  switch(currentSide) {
    case 'front':
      setDesignImages(prev => ({ ...prev, frontDesignImage: null, frontDesignImageUrl: null }));
      setDesignFileNames(prev => ({ ...prev, frontDesignImage: '' }));
      setFrontDesignSize({ width: 0, height: 0 });
      setFrontDesignCost(0);
      break;
    case 'back':
      setDesignImages(prev => ({ ...prev, backDesignImage: null, backDesignImageUrl: null }));
      setDesignFileNames(prev => ({ ...prev, backDesignImage: '' }));
      setBackDesignSize({ width: 0, height: 0 });
      setBackDesignCost(0);
      break;
    case 'leftSleeve':
      setDesignImages(prev => ({ ...prev, leftSleeveDesignImage: null, leftSleeveDesignImageUrl: null }));
      setDesignFileNames(prev => ({ ...prev, leftSleeveDesignImage: '' }));
      setLeftSleeveDesignSize({ width: 0, height: 0 });
      setLeftSleeveDesignCost(0);
      break;
    case 'rightSleeve':
      setDesignImages(prev => ({ ...prev, rightSleeveDesignImage: null, rightSleeveDesignImageUrl: null }));
      setDesignFileNames(prev => ({ ...prev, rightSleeveDesignImage: '' }));
      setRightSleeveDesignSize({ width: 0, height: 0 });
      setRightSleeveDesignCost(0);
      break;
    case 'leftHood':
      setDesignImages(prev => ({ ...prev, leftHoodDesignImage: null, leftHoodDesignImageUrl: null }));
      setDesignFileNames(prev => ({ ...prev, leftHoodDesignImage: '' }));
      setLeftHoodDesignSize({ width: 0, height: 0 });
      setLeftHoodDesignCost(0);
      break;
    case 'rightHood':
      setDesignImages(prev => ({ ...prev, rightHoodDesignImage: null, rightHoodDesignImageUrl: null }));
      setDesignFileNames(prev => ({ ...prev, rightHoodDesignImage: '' }));
      setRightHoodDesignSize({ width: 0, height: 0 });
      setRightHoodDesignCost(0);
      break;
    default:
  }

  if (fileInputRef.current) {
    fileInputRef.current.value = '';
  }
  
  // Update the selected method state
  const newSelectedMethod = {
    ...selectedMethod,
    [currentSide]: printMethod
  };
  
  setSelectedMethod(newSelectedMethod);

  // Immediately refresh clipping rects with the new method
  if (currentSide === 'front' || currentSide === 'back') {
    setTimeout(() => {
      if (currentSide === 'front') {
        refreshClippingRects(printMethod, selectedMethod.back);
      } else {
        refreshClippingRects(selectedMethod.front, printMethod);
      }
    }, 50);
  }
};

useEffect(() => {
  if (selectedMethod.front && frontDesignSize.width > 0 && frontDesignSize.height > 0) {
    updateCostAndSize(frontDesignSize.width, frontDesignSize.height, true);
  }
}, [selectedMethod.front]);

useEffect(() => {
  if (selectedMethod.back && backDesignSize.width > 0 && backDesignSize.height > 0) {
    updateCostAndSize(backDesignSize.width, backDesignSize.height, false);
  }
}, [selectedMethod.back]);


  const handleFileUpload = (e) => {
  const file = e.target.files[0];
  let activeCanvas;
  let currentSide;

  e.target.value = '';
  
  // Determine which canvas and side based on current view
  switch(view) {
    case 0:
      activeCanvas = frontCanvas;
      currentSide = 'front';
      break;
    case 1:
      activeCanvas = backCanvas;
      currentSide = 'back';
      break;
    case 2:
      activeCanvas = leftSleeveCanvas;
      currentSide = 'leftSleeve';
      break;
    case 3:
      activeCanvas = rightSleeveCanvas;
      currentSide = 'rightSleeve';
      break;
    case 4:
  activeCanvas = leftHoodCanvas;
  currentSide = 'leftHood';
  break;
case 5:
  activeCanvas = rightHoodCanvas;
  currentSide = 'rightHood';
  break;
    default:
      return;
  }
  
  // Check if print method is selected before allowing file upload
  if (!selectedMethod[currentSide]) {
    toast.error("Please select a print method before uploading design.");
    // Reset the file input
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    return;
  }

  const reader = new FileReader();
  reader.onload = (event) => {
    const img = new Image();
    img.src = event.target.result;

    img.onload = function () {
      const dpi = Math.round(img.width / (activeCanvas.width / 254));
      if (dpi < 100) {
        toast.error("Print quality bad, high resolution art required.");
        return;
      } else {
        toast.success("Print quality good.");
      }

      // Determine design type based on current view
      let designType;
      switch(view) {
        case 0:
          designType = "front";
          break;
        case 1:
          designType = "back";
          break;
        case 2:
          designType = "leftSleeve";
          break;
        case 3:
          designType = "rightSleeve";
          break;
        case 4:
         designType = "leftHood";
          break;
        case 5:
        designType = "rightHood";
         break;
        default:
          return;
      }

      // Remove existing design images from the current canvas
      const objectsToRemove = [];
      activeCanvas.getObjects().forEach((obj) => {
        // Check if the object is an image (you might need to adjust this condition based on how you identify design images)
        if (obj.type === 'image' || obj.isDesignImage) {
          objectsToRemove.push(obj);
        }
      });
      
      // Remove all identified objects
      objectsToRemove.forEach((obj) => {
        activeCanvas.remove(obj);
      });

      // Update file names and images state
      setDesignFileNames((prev) => ({
        ...prev,
        [`${designType}DesignImage`]: file.name,
      }));

      setDesignImages((prev) => ({
        ...prev,
        [`${designType}DesignImage`]: file,
      }));

      (async () => {
        try {
          const fabricImg = await FabricImage.fromURL(img.src);

          if (!fabricImg.width || !fabricImg.height) {
            throw new Error("Image dimensions are not available.");
          }

          // Mark this as a design image for easier identification
          fabricImg.isDesignImage = true;

          let maxWidth = 16;
          let maxHeight = 20;

          // If product name is 'baby tee', update max width and height
          if (productName === "Black Baby Tee" || productName === "White Baby Tee") {
            maxWidth = 10;
            maxHeight = 12;
          }


        
          
          if (designType === "leftSleeve" || designType === "rightSleeve") {
  maxWidth = 6;   // Changed from 4 to 6
  maxHeight = 20; // Changed from 4 to 20
} else if (designType === "leftHood" || designType === "rightHood") {
  maxWidth = 10;  // New: max width for hoods
  maxHeight = 15; // New: max height for hoods
}else if (designType === "front" && selectedMethod.front === "DTF"){
              maxWidth = 14;   // Changed from 4 to 6
              maxHeight = 16; // Changed from 4 to 20
          }


        //   if (designType === "leftSleeve" || designType === "rightSleeve") {
        //   maxWidth = 4;
        //   maxHeight = 4;
        //    }
          // Define scale factors and position for all sides
          let scaleFactor;
          switch(designType) {
   case "front":
    const frontClipRect = getClippingRect('front', selectedMethod.front || 'DTG');
    scaleFactor = Math.min(frontClipRect.width / fabricImg.width, frontClipRect.height / fabricImg.height);
    break;
  case "back":
    const backClipRect = getClippingRect('back', selectedMethod.back || 'DTG');
    scaleFactor = Math.min(backClipRect.width / fabricImg.width, backClipRect.height / fabricImg.height);
    break;
            case "leftSleeve":
              scaleFactor = Math.min(product.clippingRects.leftsleeve.width / fabricImg.width, product.clippingRects.leftsleeve.height / fabricImg.height);
              break;
            case "rightSleeve":
              scaleFactor = Math.min(product.clippingRects.rightsleeve.width / fabricImg.width, product.clippingRects.rightsleeve.height / fabricImg.height);
              break;
            case "leftHood":
  scaleFactor = Math.min(product.clippingRects.lefthood.width / fabricImg.width, product.clippingRects.lefthood.height / fabricImg.height);
  break;
case "rightHood":
  scaleFactor = Math.min(product.clippingRects.righthood.width / fabricImg.width, product.clippingRects.righthood.height / fabricImg.height);
  break;
               default:
          }

          fabricImg.scale(scaleFactor);




          // Define clipping paths for all sides
          let clippingRect, clippingLeft, clippingTop, clippingWidth, clippingHeight;
          
          switch(designType) {
             case "front":
    const frontClipRect = getClippingRect('front', selectedMethod.front || 'DTG');
    clippingLeft = frontClipRect.left;
    clippingTop = frontClipRect.top;
    clippingWidth = frontClipRect.width;
    clippingHeight = frontClipRect.height;
    break;
  case "back":
    const backClipRect = getClippingRect('back', selectedMethod.back || 'DTG');
    clippingLeft = backClipRect.left;
    clippingTop = backClipRect.top;
    clippingWidth = backClipRect.width;
    clippingHeight = backClipRect.height;
    break;
            case "leftSleeve":
              clippingLeft = product.clippingRects.leftsleeve.left;
              clippingTop = product.clippingRects.leftsleeve.top;
              clippingWidth = product.clippingRects.leftsleeve.width;
              clippingHeight = product.clippingRects.leftsleeve.height;
              clippingRect = new Rect({
                left: clippingLeft,
                top: clippingTop,
                width: clippingWidth,
                height: clippingHeight,
                absolutePositioned: true,
              });
              break;
            case "rightSleeve":
              clippingLeft = product.clippingRects.rightsleeve.left;
              clippingTop = product.clippingRects.rightsleeve.top;
              clippingWidth = product.clippingRects.rightsleeve.width;
              clippingHeight = product.clippingRects.rightsleeve.height;
              clippingRect = new Rect({
                left: clippingLeft,
                top: clippingTop,
                width: clippingWidth,
                height: clippingHeight,
                absolutePositioned: true,
              });
              break;
           case "leftHood":
  clippingLeft = product.clippingRects.lefthood.left;
  clippingTop = product.clippingRects.lefthood.top;
  clippingWidth = product.clippingRects.lefthood.width;
  clippingHeight = product.clippingRects.lefthood.height;
       clippingRect = new Rect({
                left: clippingLeft,
                top: clippingTop,
                width: clippingWidth,
                height: clippingHeight,
                absolutePositioned: true,
              });
  break;
case "rightHood":
  clippingLeft = product.clippingRects.righthood.left;
  clippingTop = product.clippingRects.righthood.top;
  clippingWidth = product.clippingRects.righthood.width;
  clippingHeight = product.clippingRects.righthood.height;
        clippingRect = new Rect({
                left: clippingLeft,
                top: clippingTop,
                width: clippingWidth,
                height: clippingHeight,
                absolutePositioned: true,
              });
              break;
               default:
          }

          // Set image position (centered within clipping area)
          const imageLeft = clippingLeft + (clippingWidth - fabricImg.width * scaleFactor) / 2;
          const imageTop = clippingTop + (clippingHeight - fabricImg.height * scaleFactor) / 2;

          fabricImg.set({
            left: imageLeft,
            top: imageTop,
            clipPath: clippingRect,
          });

          // Add the new image to the canvas
          activeCanvas.add(fabricImg);

          // Calculate initial size in units
          const initialWidthUnits = (fabricImg.width * scaleFactor) / (clippingWidth / maxWidth);
          const initialHeightUnits = (fabricImg.height * scaleFactor) / (clippingHeight / maxHeight);

          updateCostAndSize(initialWidthUnits, initialHeightUnits, designType);

          fabricImg.setControlsVisibility({
            mt: false, // middle top
            mb: false, // middle bottom
            ml: false, // middle left
            mr: false, // middle right
            tl: true,  // top left
            tr: true,  // top right
            bl: true,  // bottom left
            br: true,  // bottom right
            mtr: true  // rotation handle
          });

          // Check if device is mobile for larger corner sizes
          const isMobile = window.innerWidth <= 768;
          
          fabricImg.set({
            cornerSize: isMobile ? 60 : 30, // Larger control corners for mobile
            borderWidth: isMobile ? 8 : 4, // Thicker border for mobile
            borderColor: '#007bff', // Blue border color
            cornerColor: '#007bff', // Blue corner color
            cornerStrokeColor: '#ffffff', // White stroke for corners
            cornerStrokeWidth: isMobile ? 8 : 4, // Thicker stroke for mobile
            transparentCorners: false, // Makes corners opaque
            // Enhanced controls for better interaction
            hasControls: true,
            hasBorders: true,
            lockMovementX: false,
            lockMovementY: false,
            lockRotation: false,
            lockScalingX: false,
            lockScalingY: false,
            // Custom control styles
            cornerStyle: 'rect', // Square corners for resizing
            cornerDashArray: null,
            // Rotation control
            hasRotatingPoint: true,
            rotatingPointOffset: isMobile ? 70 : 50, // Larger rotation handle distance for mobile
            // Better visual feedback
            hoverCursor: 'move',
            moveCursor: 'move',
            defaultCursor: 'default',
            rotationCursor: 'crosshair',
            // Enhanced mobile support - significantly larger touch targets
            touchCornerSize: isMobile ? 80 : 35, // Much larger touch targets for mobile
            // Custom control rendering
            renderControls: true,
            // Better visibility
            shadow: {
              color: 'rgba(0, 0, 0, 0.15)',
              blur: 6,
              offsetX: 3,
              offsetY: 3
            }
          });

          // Add custom control rendering for better visual feedback
          fabricImg.on('selected', () => {
            // Add visual indicators when object is selected
            const isMobile = window.innerWidth <= 768;
            fabricImg.set({
              borderColor: '#007bff',
              cornerColor: '#007bff',
              cornerStrokeColor: '#ffffff',
              cornerStrokeWidth: isMobile ? 8 : 4,
              cornerSize: isMobile ? 60 : 30,
              borderWidth: isMobile ? 8 : 4
            });
          });

          fabricImg.on('deselected', () => {
            // Reset visual indicators when object is deselected
            const isMobile = window.innerWidth <= 768;
            fabricImg.set({
              borderColor: '#007bff',
              cornerColor: '#007bff',
              cornerStrokeColor: '#ffffff',
              cornerStrokeWidth: isMobile ? 8 : 4,
              cornerSize: isMobile ? 60 : 30,
              borderWidth: isMobile ? 8 : 4
            });
          });

          fabricImg.on('scaling', () => {
            const object = fabricImg;
            
            let adjustedWidthUnits, adjustedHeightUnits;
            
            switch(view) {
                 case 0: // Front
      const frontClipRect = getClippingRect('front', selectedMethod.front || 'DTG');
      adjustedWidthUnits = (object.width * object.scaleX) / (frontClipRect.width / maxWidth);
      adjustedHeightUnits = (object.height * object.scaleY) / (frontClipRect.height / maxHeight);
      updateCostAndSize(adjustedWidthUnits, adjustedHeightUnits, 'front');
      break;
    case 1: // Back
      const backClipRect = getClippingRect('back', selectedMethod.back || 'DTG');
      adjustedWidthUnits = (object.width * object.scaleX) / (backClipRect.width / maxWidth);
      adjustedHeightUnits = (object.height * object.scaleY) / (backClipRect.height / maxHeight);
      updateCostAndSize(adjustedWidthUnits, adjustedHeightUnits, 'back');
      break;
              case 2: // Left Sleeve
                adjustedWidthUnits = (object.width * object.scaleX) / (product.clippingRects.leftsleeve.width / maxWidth);
                adjustedHeightUnits = (object.height * object.scaleY) / (product.clippingRects.leftsleeve.height / maxHeight);
                updateCostAndSize(adjustedWidthUnits, adjustedHeightUnits, 'leftSleeve');
                break;
              case 3: // Right Sleeve
                adjustedWidthUnits = (object.width * object.scaleX) / (product.clippingRects.rightsleeve.width / maxWidth);
                adjustedHeightUnits = (object.height * object.scaleY) / (product.clippingRects.rightsleeve.height / maxHeight);
                updateCostAndSize(adjustedWidthUnits, adjustedHeightUnits, 'rightSleeve');
                break;
              case 4: // Left Hood
  adjustedWidthUnits = (object.width * object.scaleX) / (product.clippingRects.lefthood.width / maxWidth);
  adjustedHeightUnits = (object.height * object.scaleY) / (product.clippingRects.lefthood.height / maxHeight);
  updateCostAndSize(adjustedWidthUnits, adjustedHeightUnits, 'leftHood');
  break;
case 5: // Right Hood
  adjustedWidthUnits = (object.width * object.scaleX) / (product.clippingRects.righthood.width / maxWidth);
  adjustedHeightUnits = (object.height * object.scaleY) / (product.clippingRects.righthood.height / maxHeight);
  updateCostAndSize(adjustedWidthUnits, adjustedHeightUnits, 'rightHood');
  break;  
                 default:
            }
          });

          fabricImg.on('scaled', () => {
            const object = fabricImg;
            if (object) {
              object.set({
                scaleX: 1,
                scaleY: 1,
              });
            }
          });

          // Upload to Firebase Storage
          const timestamp = Date.now();
          const fileRef = ref(Storage, `designs/${designType}-${timestamp}.png`);
          await uploadBytes(fileRef, file);

          const designImageUrl = await getDownloadURL(fileRef);
          setDesignImages((prev) => ({
            ...prev,
            [`${designType}DesignImageUrl`]: designImageUrl,
          }));

        } catch (error) {
          console.error("Error with Fabric Image: ", error);
        } finally {
          setIsLoading(false); // Stop loading
        }
      })();

    };
  };

  reader.readAsDataURL(file);
  setDrawerOpen(false);
};


const scrollToError = () => {
  if (formContainerRef.current) {
    formContainerRef.current.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'start' 
    });
  }
};

  const handleSubmit = async (status) => {


    const frontImageUrl = designImages.frontDesignImageUrl || null;
    const backImageUrl = designImages.backDesignImageUrl || null;
    


    // Check if required fields are empty
    let isValid = true;
    const newErrors = {};

    if (!designName) {
      newErrors.designName = 'Design Name is required';
      isValid = false;
    }
    if (!description) {
      newErrors.description = 'Description is required';
      isValid = false;
    }
    if (!sellingPrice) {
      newErrors.sellingPrice = 'Selling Price is required';
      isValid = false;
    }

    // if (!designImages.frontDesignImage && !designImages.backDesignImage) {
    //   newErrors.designImages = 'Please upload at least one design image (front or back)';
    //   isValid = false;
    // }


    if (!isBlankProduct) {
  if (!designImages.frontDesignImage && !designImages.backDesignImage) {
    newErrors.designImages = 'Please upload at least one design image (front or back)';
    isValid = false;
  }

  if (!selectedMethod.front && !selectedMethod.back) {
    newErrors.selectedMethod = 'Please select a print method';
    isValid = false;
  }
}

    // if (!selectedMethod.front && !selectedMethod.back) {
    //   newErrors.selectedMethod = 'Please select a print method';
    //   isValid = false;
    // }

    // If validation fails, update error state and return
       if (!isValid) {
    setErrors(newErrors);
    scrollToError(); // Add this line
    return;
  }

    setIsSubmitting(true);
    setIsLoading(true);

    let progress = 0; // Initial progress

    // Function to update progress
    const updateProgress = (percentage) => {
      setProgress(percentage); // Update the progress state
    };

    try {
      // Function to convert Data URI to Blob
      const dataURItoBlob = (dataURI) => {
        const byteString = dataURI.split(',')[1];
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        const ia = new Uint8Array(atob(byteString).split('').map(char => char.charCodeAt(0)));
        return new Blob([ia], { type: mimeString });
      };

      // Save final canvas design to Firebase Storage
      const saveCanvasToStorage = async (canvas, canvasName) => {
        canvas.getObjects("rect").forEach((rect) => rect.set({ visible: false })); // Hide any visible rectangles
        canvas.renderAll();
        const timestamp = Date.now();
        const canvasPNG = canvas.toDataURL({ format: 'jpeg' }); // Save as PNG for quality
        const canvasRef = ref(Storage, `mockups/${designName}-${canvasName}-${timestamp}.jpeg`);

        updateProgress(30);

        await uploadBytes(canvasRef, dataURItoBlob(canvasPNG));
        const url = await getDownloadURL(canvasRef);
        return url;
      };

    

      // Generate SKUs for different sizes
const generateSKUs = () => {
  const randomNum = Math.floor(Math.random() * 1000000);
  const productSizes = product.sizes || []; // Get sizes from the product object
  
  // Generate SKUs for each size in the product.sizes array
  return productSizes.map(size => `u-${randomNum}-${size}`);
};
      const skus = generateSKUs();

      // Export the final combined design for front and back mockups
      const frontMockupUrl = await saveCanvasToStorage(frontCanvas, 'front');
      updateProgress(50); // Update progress to 50% after front mockup
      const backMockupUrl = await saveCanvasToStorage(backCanvas, 'back');
      updateProgress(70); // Update progress to 70% after back mockup


      const images = {
  front: frontMockupUrl,
  back: backMockupUrl,
};

// Only add sleeve mockups if design images exist
if (designImages.leftSleeveDesignImage) {
  images.leftSleeve = await saveCanvasToStorage(leftSleeveCanvas, 'leftSleeve');
}
if (designImages.rightSleeveDesignImage) {
  images.rightSleeve = await saveCanvasToStorage(rightSleeveCanvas, 'rightSleeve');
}
if (designImages.leftHoodDesignImage) {
  images.leftHood = await saveCanvasToStorage(leftHoodCanvas, 'leftHood');
}
if (designImages.rightHoodDesignImage) {
  images.rightHood = await saveCanvasToStorage(rightHoodCanvas, 'rightHood');
}

      // Create design document in Firestore
      const designRef = doc(collection(db, 'users', user.uid, 'designs'));
     await setDoc(designRef, {
  designName,
  description,
  sellingPrice,
  totalPrice,
  productType: 'Hoodie',
  frontDesign: frontImageUrl,
  backDesign: backImageUrl,
  leftSleeveDesign: designImages.leftSleeveDesignImageUrl || null,
  rightSleeveDesign: designImages.rightSleeveDesignImageUrl || null,
  leftHoodDesign: designImages.leftHoodDesignImageUrl || null,
  rightHoodDesign: designImages.rightHoodDesignImageUrl || null,
  images,
  costs: {
    front: frontDesignCost,
    back: backDesignCost,
    leftSleeve: leftSleeveDesignCost,
    rightSleeve: rightSleeveDesignCost,
    leftHood: leftHoodDesignCost,
rightHood: rightHoodDesignCost,
  },
  Printsizes: {
    front: frontDesignSize,
    back: backDesignSize,
    leftSleeve: leftSleeveDesignSize,
    rightSleeve: rightSleeveDesignSize,
    leftHood: leftHoodDesignSize,
rightHood: rightHoodDesignSize,
  },
  productName: product.name,
  productGSM: product.GSM,
  SKUs: skus,
  baseCost: product.BASE_COST,
  PrintCost: frontDesignCost + backDesignCost + leftSleeveDesignCost + rightSleeveDesignCost + leftHoodDesignCost + rightHoodDesignCost,
  timestamp: serverTimestamp(),
  printProfile: printProfile,
  printMethod: {
    front: selectedMethod.front,
    back: selectedMethod.back,
    leftSleeve: selectedMethod.leftSleeve,
    rightSleeve: selectedMethod.rightSleeve,
    leftHood: selectedMethod.leftHood,
   rightHood: selectedMethod.rightHood
  },
  userId: user.uid,
  isBlankProduct: isBlankProduct
});

      const userDocRef = doc(db, 'users', user.uid);
      const userDoc = await getDoc(userDocRef);
  
      if (!userDoc.exists()) {
        toast.error("User data not found.");
        return;
      }
  
      const userData = userDoc.data();
      const userShop = userData.shop;
      
  
      // Check if the 'shop' field exists in the user's data
      if (!userShop) {
        toast.error("Shop information is missing. Please check your user data.");
        return;
      }

      // Create payload for the external API
      const payload = {
        productName: productName,
        frontImage: frontMockupUrl,
        backImage: backMockupUrl,
        frontDesign: frontImageUrl, // Use the URL from state
        backDesign: backImageUrl,
        shop: userShop,
        designName: designName,
        description: description,
        sellingPrice: sellingPrice,
        SKUs: skus,
        PrintCost: frontDesignCost + backDesignCost,
        userId: user.uid
      };

      // Send the data to your external API (to create a draft product)
      await axios.post('https://ufb-1.onrender.com/api/create-active-product', {
        ...payload,
        status, // Add status to the payload here
      });

      // Redirect after successful submission
      toast.success('Design uploaded successfully!');
      setShowModal(true);
      // navigate(`/products?shop=${shop}`);
    } catch (error) {
      console.error("Error uploading design:", error);
      toast.error("Failed to upload design.");
    } finally {
      setIsSubmitting(false);
      setIsLoading(false);
      setProgress(100);
    }
};


useEffect(() => {
  const fetchUserShop = async () => {
    // Assuming db is the Firestore instance and user.uid is the current user's ID
    const userDocRef = doc(db, 'users', user.uid);
    const userDoc = await getDoc(userDocRef);

    if (!userDoc.exists()) {
      toast.error("User data not found.");
      return;
    }

    const userData = userDoc.data();
    const userShop = userData.shop;
    setUserShop(userShop); // Update the userShop state
    
    // setLoading(false); // Mark as done loading
  };

  fetchUserShop();
}, [user.uid]); // Fetch only when the user.uid changes



const handleSaveProduct = async () => {


  const frontImageUrl = designImages.frontDesignImageUrl || null;
  const backImageUrl = designImages.backDesignImageUrl || null;


  setErrors({
    designName: '',
    description: '',
    sellingPrice: '',
    designImages: '',
    selectedMethod: ''
  });

  // Check if required fields are empty
  let isValid = true;
  const newErrors = {};

  if (!designName) {
    newErrors.designName = 'Design Name is required';
    isValid = false;
  }
  if (!description) {
    newErrors.description = 'Description is required';
    isValid = false;
  }
  if (!sellingPrice) {
    newErrors.sellingPrice = 'Selling Price is required';
    isValid = false;
  }
  // if (!designImages.frontDesignImage && !designImages.backDesignImage) {
  //   newErrors.designImages = 'Please upload at least one design image (front or back)';
  //   isValid = false;
  // }

  // if (!selectedMethod.front && !selectedMethod.back) {
  //   newErrors.selectedMethod = 'Please select a print method';
  //   isValid = false;
  // }

  // Only validate design images and print methods if it's NOT a blank product
if (!isBlankProduct) {
  if (!designImages.frontDesignImage && !designImages.backDesignImage) {
    newErrors.designImages = 'Please upload at least one design image (front or back)';
    isValid = false;
  }

  if (!selectedMethod.front && !selectedMethod.back) {
    newErrors.selectedMethod = 'Please select a print method';
    isValid = false;
  }
}

  // If validation fails, update error state and return
  if (!isValid) {
    setErrors(newErrors);
    scrollToError(); // Add this line
    return;
  }

  setIsSubmitting(true);
  setIsLoading(true);

  let progress = 0; // Initial progress

  // Function to update progress
  const updateProgress = (percentage) => {
    setProgress(percentage); // Update the progress state
  };

  try {
    // Function to convert Data URI to Blob
    const dataURItoBlob = (dataURI) => {
      const byteString = dataURI.split(',')[1];
      const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      const ia = new Uint8Array(atob(byteString).split('').map(char => char.charCodeAt(0)));
      return new Blob([ia], { type: mimeString });
    };

    // Save final canvas design to Firebase Storage
    const saveCanvasToStorage = async (canvas, canvasName) => {
      canvas.getObjects("rect").forEach((rect) => rect.set({ visible: false })); // Hide any visible rectangles
      canvas.renderAll();
      const timestamp = Date.now();
      const canvasPNG = canvas.toDataURL({ format: 'jpeg' }); // Save as PNG for quality
      const canvasRef = ref(Storage, `mockups/${designName}-${canvasName}-${timestamp}.jpeg`);

      updateProgress(30);

      await uploadBytes(canvasRef, dataURItoBlob(canvasPNG));
      const url = await getDownloadURL(canvasRef);
      return url;
    };

  

    // Generate SKUs for different sizes
const generateSKUs = () => {
const randomNum = Math.floor(Math.random() * 1000000);
const productSizes = product.sizes || []; // Get sizes from the product object

// Generate SKUs for each size in the product.sizes array
return productSizes.map(size => `u-${randomNum}-${size}`);
};
    const skus = generateSKUs();

    // Export the final combined design for front and back mockups
    const frontMockupUrl = await saveCanvasToStorage(frontCanvas, 'front');
    updateProgress(50); // Update progress to 50% after front mockup
    const backMockupUrl = await saveCanvasToStorage(backCanvas, 'back');
    updateProgress(70); // Update progress to 70% after back mockup

          const images = {
  front: frontMockupUrl,
  back: backMockupUrl,
};


    // Create design document in Firestore
   if (designImages.leftSleeveDesignImage) {
  images.leftSleeve = await saveCanvasToStorage(leftSleeveCanvas, 'leftSleeve');
}
if (designImages.rightSleeveDesignImage) {
  images.rightSleeve = await saveCanvasToStorage(rightSleeveCanvas, 'rightSleeve');
}
if (designImages.leftHoodDesignImage) {
  images.leftHood = await saveCanvasToStorage(leftHoodCanvas, 'leftHood');
}
if (designImages.rightHoodDesignImage) {
  images.rightHood = await saveCanvasToStorage(rightHoodCanvas, 'rightHood');
}

      // Create design document in Firestore
      const designRef = doc(collection(db, 'users', user.uid, 'designs'));
     await setDoc(designRef, {
  designName,
  description,
  sellingPrice,
  totalPrice,
  productType: 'Hoodie',
  frontDesign: frontImageUrl,
  backDesign: backImageUrl,
  leftSleeveDesign: designImages.leftSleeveDesignImageUrl || null,
  rightSleeveDesign: designImages.rightSleeveDesignImageUrl || null,
  leftHoodDesign: designImages.leftHoodDesignImageUrl || null,
  rightHoodDesign: designImages.rightHoodDesignImageUrl || null,
  
  images,
  costs: {
    front: frontDesignCost,
    back: backDesignCost,
    leftSleeve: leftSleeveDesignCost,
    rightSleeve: rightSleeveDesignCost,
        leftHood: leftHoodDesignCost,
rightHood: rightHoodDesignCost,
  },
  Printsizes: {
    front: frontDesignSize,
    back: backDesignSize,
    leftSleeve: leftSleeveDesignSize,
    rightSleeve: rightSleeveDesignSize,
        leftHood: leftHoodDesignSize,
rightHood: rightHoodDesignSize,
  },
  productName: product.name,
  productGSM: product.GSM,
  SKUs: skus,
  baseCost: product.BASE_COST,
  PrintCost: frontDesignCost + backDesignCost + leftSleeveDesignCost + rightSleeveDesignCost + leftHoodDesignCost + rightHoodDesignCost,
  timestamp: serverTimestamp(),
  printProfile: printProfile,
  printMethod: {
    front: selectedMethod.front,
    back: selectedMethod.back,
    leftSleeve: selectedMethod.leftSleeve,
    rightSleeve: selectedMethod.rightSleeve,
    leftHood: selectedMethod.leftHood,
   rightHood: selectedMethod.rightHood
  },
  userId: user.uid,
  isBlankProduct: isBlankProduct
});
    // Redirect after successful submission
    toast.success('Design uploaded successfully!');
    setShowModal(true);
    // navigate(`/products?shop=${shop}`);
  } catch (error) {
    console.error("Error uploading design:", error);
    toast.error("Failed to upload design.");
  } finally {
    setIsSubmitting(false);
    setIsLoading(false);
    setProgress(100);
  }
};


const handleGoToProducts = () => {
  if (user?.uid === "hl6gcaUDIFXQkYUxppfAAHycLtO2") {
    // Redirect this special user to /product-new
    navigate('/products-new');
  } else {
    // Redirect everyone else to /products
    navigate('/products');
  }
};


  const handleRotate = () => {
    // event.preventDefault(); 
    const activeCanvas = view === 0 ? frontCanvas : backCanvas;
    const activeObjects = activeCanvas.getActiveObjects();

    activeObjects.forEach((obj) => {
      obj.rotate(obj.angle + 90);
      obj.setCoords();
    });
    activeCanvas.renderAll();
  };

const handleDelete = () => {
  let activeCanvas;
  let view_type;
  
  switch(view) {
    case 0:
      activeCanvas = frontCanvas;
      view_type = 'front';
      break;
    case 1:
      activeCanvas = backCanvas;
      view_type = 'back';
      break;
    case 2:
      activeCanvas = leftSleeveCanvas;
      view_type = 'leftSleeve';
      break;
    case 3:
      activeCanvas = rightSleeveCanvas;
      view_type = 'rightSleeve';
      break;
    case 4:
  activeCanvas = leftHoodCanvas;
  view_type = 'leftHood';
  break;
case 5:
  activeCanvas = rightHoodCanvas;
  view_type = 'rightHood';
  break;
  default:
  }
  
  const activeObjects = activeCanvas.getActiveObjects();

  activeObjects.forEach((obj) => {
    activeCanvas.remove(obj);
  });
  activeCanvas.discardActiveObject();
  activeCanvas.renderAll();

  // Reset design size and cost based on current view
  updateCostAndSize(0, 0, view_type);
};


  const handleShowSizeChart = () => {
    setIsSizeChartVisible(!isSizeChartVisible);
  };


  const setOpenDrawer = (isOpen) => {
    setDrawerOpen(isOpen);
    
    // Prevent body scroll when drawer is open on mobile
    if (isOpen && window.innerWidth <= 768) {
      document.body.classList.add('drawer-open');
    } else {
      document.body.classList.remove('drawer-open');
    }
  };

  

  return (
  <div className="flex bg-white min-h-screen">
    {/* Sidebar */}
    <Sidebar />

    {/* Main content */}
    <div className="flex flex-col w-full md:ml-64 max-h-screen overflow-y-auto">
      <Header />
      
 <div className="flex flex-col lg:flex-row gap-4 items-start p-4 sm:p-6 min-h-[calc(100vh-80px)]">
        {/* Mobile backdrop overlay */}
        {drawerOpen && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-[999] lg:hidden"
            onClick={() => setOpenDrawer(false)}
          />
        )}
        
        {/* Left Section - Upload Form */}
        <div className="w-full lg:w-1/4 lg:max-w-[320px] shrink-0">
          <div
            className={`${
              drawerOpen ? "left-0" : "-left-full"
            } fixed lg:static top-0 lg:top-auto w-full lg:w-auto h-screen lg:h-auto bg-white lg:bg-transparent transition-all duration-300 ease-in-out p-4 lg:p-0 z-[1000] lg:z-auto mobile-drawer-content shadow-lg lg:shadow-none flex flex-col`}
          >
            {/* Mobile close button */}
            <div className="flex justify-between items-center mb-4 lg:hidden">
              <button
                className="bg-gray-800 hover:bg-gray-900 text-white text-sm px-3 py-2 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg active:scale-95"
                onClick={() => setOpenDrawer(false)}
              >
                <FaTimes />
              </button>
            </div>

            {/* Form container */}
              <h2 className="pb-4 uppercase create-design-title text-center text-gray-800">Create Design</h2>

              {/* Blank Product Toggle */}
<div className="flex items-center justify-center gap-3 mb-4 p-3 bg-gray-50 rounded-lg">
  <span className="text-sm font-medium text-gray-700">Blank Product</span>
  <label className="relative inline-flex items-center cursor-pointer">
    <input
      type="checkbox"
      checked={isBlankProduct}
      onChange={(e) => handleBlankProductToggle(e.target.checked)}
      className="sr-only peer"
    />
    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
  </label>
</div>

{isBlankProduct && (
  <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
    <p className="text-sm text-blue-800 text-center">
     We add a ₹25 fee for shipping blank products.
    </p>
  </div>
)}
            <div className="space-y-4 flex-1 overflow-y-auto" ref={formContainerRef}>

              <form onSubmit={handleSubmit} className="space-y-6">
           
                {/* Print Method - Only show when NOT blank product */}
{!isBlankProduct && (
  <div className="text-center">
    <h3 className="tracking-wide print-method-title">PRINT METHOD</h3>
    <div className="flex justify-center gap-2 mt-3 flex-wrap">
      {availablePrintMethods
        .filter((printMethod) => {
          if (view === 2 || view === 3) {
            const selected =
              selectedMethod[view === 2 ? "leftSleeve" : "rightSleeve"];
            return selected === printMethod;
          }

          if (view === 4 || view === 5) {
            const selected = selectedMethod[view === 4 ? "leftHood" : "rightHood"];
            return selected === printMethod;
          }
          return true;
        })
        .map((printMethod) => (
          <button
            key={printMethod}
            className={`px-4 py-2 rounded-full text-sm transition px-[5vw] py-4 ${
              selectedMethod[
                view === 0
                  ? "front"
                  : view === 1
                  ? "back"
                  : view === 2
                  ? "leftSleeve"
                  : view === 3
                  ? "rightSleeve"
                  : view === 4
                  ? "leftHood"
                  : "rightHood"
              ] === printMethod
                ? "bg-gray-800 text-white"
                : "bg-gray-200 hover:bg-blue-600 hover:text-white"
            }`}
            onClick={(event) => {
              event.preventDefault();
              handlePrintMethodChange(printMethod);
            }}
          >
            {printMethod}
          </button>
        ))}
    </div>
    {errors.selectedMethod && (
      <p className="text-red-500 text-sm mt-2">{errors.selectedMethod}</p>
    )}
  </div>
)}

                {/* Print Profile - Add this section after Print Method */}
{/* <div className="text-center">
  <h3 className="tracking-wide print-method-title">PRINT PROFILE</h3>
  <div className="flex justify-center gap-2 mt-3 flex-wrap">
    <button
      className={`px-4 py-2 rounded-full text-sm transition px-[5vw] py-4 ${
        printProfile === 'standard'
          ? "bg-gray-800 text-white"
          : "bg-gray-200 hover:bg-blue-600 hover:text-white"
      }`}
      onClick={(e) => {
        e.preventDefault();
        setPrintProfile('standard');
      }}
    >
      Standard Garment
    </button>
    <button
      className={`px-4 py-2 rounded-full text-sm transition px-[5vw] py-4 ${
        printProfile === 'heavy'
          ? "bg-gray-800 text-white"
          : "bg-gray-200 hover:bg-blue-600 hover:text-white"
      }`}
      onClick={(e) => {
        e.preventDefault();
        setPrintProfile('heavy');
      }}
    >
      Heavy Garment
    </button>
  </div>
</div> */}


{/* Print Profile - Only show for DTG */}
{/* {(selectedMethod.front === 'DTG' || 
  selectedMethod.back === 'DTG' || 
  selectedMethod.leftSleeve === 'DTG' || 
  selectedMethod.rightSleeve === 'DTG' ||
  selectedMethod.leftHood === 'DTG' ||
  selectedMethod.rightHood === 'DTG') && (
  <div className="text-center">
    <h3 className="tracking-wide print-method-title">PRINT PROFILE</h3>
    <div className="flex justify-center gap-2 mt-3 flex-wrap">
      <button
        className={`px-4 py-2 rounded-full text-sm transition px-[5vw] py-4 ${
          printProfile === 'standard'
            ? "bg-gray-800 text-white"
            : "bg-gray-200 hover:bg-blue-600 hover:text-white"
        }`}
        onClick={(e) => {
          e.preventDefault();
          setPrintProfile('standard');
        }}
      >
        Standard Garment
      </button>
      <button
        className={`px-4 py-2 rounded-full text-sm transition px-[5vw] py-4 ${
          printProfile === 'heavy'
            ? "bg-gray-800 text-white"
            : "bg-gray-200 hover:bg-blue-600 hover:text-white"
        }`}
        onClick={(e) => {
          e.preventDefault();
          setPrintProfile('heavy');
        }}
      >
        Heavy Garment
      </button>
    </div>
     <p className="text-xs text-gray-500 mt-2">
      {printProfile === 'standard' 
        ? 'Suggested for Light and Mid weight garments.'
        : 'Suggested for heavy weight garments.'}
    </p>
  </div>
)} */}


{/* Print Profile - Only show for DTG on front or back */}
{((view === 0 && selectedMethod.front === 'DTG') || 
  (view === 1 && selectedMethod.back === 'DTG')) && (
  <div className="text-center">
    <h3 className="tracking-wide print-method-title">PRINT PROFILE</h3>
    <div className="flex justify-center gap-2 mt-3 flex-wrap">
      <button
        className={`px-4 py-2 rounded-full text-sm transition min-w-[200px] py-3 ${
          printProfile[view === 0 ? 'front' : 'back'] === 'standard'
            ? "bg-gray-800 text-white"
            : "bg-gray-200 hover:bg-blue-600 hover:text-white"
        }`}
        onClick={(e) => {
          e.preventDefault();
          const currentSide = view === 0 ? 'front' : 'back';
          setPrintProfile(prev => ({
            ...prev,
            [currentSide]: 'standard'
          }));
        }}
      >
        Standard Garment
      </button>
      <button
        className={`px-4 py-2 rounded-full text-sm transition min-w-[200px] py-3 ${
          printProfile[view === 0 ? 'front' : 'back'] === 'heavy'
            ? "bg-gray-800 text-white"
            : "bg-gray-200 hover:bg-blue-600 hover:text-white"
        }`}
        onClick={(e) => {
          e.preventDefault();
          const currentSide = view === 0 ? 'front' : 'back';
          setPrintProfile(prev => ({
            ...prev,
            [currentSide]: 'heavy'
          }));
        }}
      >
        Heavy Garment
      </button>
    </div>
    <p className="text-xs text-gray-500 mt-2">
      {printProfile[view === 0 ? 'front' : 'back'] === 'standard' 
        ? 'Suggested for Light and Mid weight garments.'
        : 'Suggested for heavy weight garments.'}
    </p>
  </div>
)}



                {/* Upload Image */}
                <div>
                  <label className="block mb-1 font-medium">Upload Design Image</label>
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".png"
                    onChange={handleFileUpload}
                    required
                    className="hidden"
                    id="designImage"
                  />
                  <label
                    htmlFor="designImage"
                    className="inline-block px-4 py-2 cursor-pointer rounded-lg border border-gray-400 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    + Add Image
                  </label>
                  {Object.keys(designFileNames).map((key) =>
                    designFileNames[key] ? (
                      <p key={key} className="text-sm mt-1 text-gray-600">
                        Uploaded: {designFileNames[key]}
                      </p>
                    ) : null
                  )}
                </div>

                {/* Product Name */}
                <div>
                  <label htmlFor="designName" className="block mb-1 font-medium">
                    Product Name
                  </label>
                  <input
                    type="text"
                    id="designName"
                    value={designName}
                    onChange={(e) => setDesignName(e.target.value)}
                    placeholder="Enter product name"
                    required
                    className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 outline-none"
                  />
                  {errors.designName && (
                    <p className="text-red-500 text-sm mt-1">{errors.designName}</p>
                  )}
                </div>

                {/* Description */}
                <div>
                  <label htmlFor="description" className="block mb-1 font-medium">
                    Description
                  </label>
                  <textarea
                    id="description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Enter description"
                    required
                    className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 outline-none resize-y"
                  />
                  {errors.description && (
                    <p className="text-red-500 text-sm mt-1">{errors.description}</p>
                  )}
                </div>

                {/* Size Chart */}
                <div>
                  <span
                    onClick={handleShowSizeChart}
                    className="text-blue-600 underline cursor-pointer text-sm"
                  >
                    View Size Chart
                  </span>
                  {isSizeChartVisible && (
                    <div className="mt-3 text-center">
                      <img
                        src={sizeChart}
                        alt="Size Chart"
                        className="max-w-full h-auto rounded"
                      />
                    </div>
                  )}
                </div>

                {/* Product Info */}
                <div className="text-sm">
                  <span className="font-medium">GSM:</span>{" "}
                  <span className="font-semibold">{product.GSM}</span>
                </div>
              </form>

              {/* Print Details Section - Mobile Only */}
              <div className="lg:hidden mobile-print-details">
                <h3 className="text-lg font-semibold mb-4 text-center print-method-title">Print Details</h3>
                
                {/* Print Details Grid */}
                <div className="grid grid-cols-3 gap-3 text-xs mb-6">
                  {[
                    { title: "Front", type: selectedMethod.front, size: frontDesignSize, cost: frontDesignCost },
                    { title: "Back", type: selectedMethod.back, size: backDesignSize, cost: backDesignCost },
                    { title: "L Sleeve", type: selectedMethod.leftSleeve, size: leftSleeveDesignSize, cost: leftSleeveDesignCost },
                    { title: "R Sleeve", type: selectedMethod.rightSleeve, size: rightSleeveDesignSize, cost: rightSleeveDesignCost },
                    { title: "L Hood", type: selectedMethod.leftHood, size: leftHoodDesignSize, cost: leftHoodDesignCost },
                    { title: "R Hood", type: selectedMethod.rightHood, size: rightHoodDesignSize, cost: rightHoodDesignCost },
                  ].map((detail) => (
    <div key={detail.title} className="p-3 border border-gray-200 rounded-md bg-white shadow-sm">
      <h4 className="font-medium text-gray-800 mb-2 text-center">{detail.title}</h4>
      <div className="space-y-1">
        <div className="flex justify-between">
          <span className="text-gray-600">Type:</span>
          <span className="font-medium">{detail.type || "-"}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Size:</span>
          <span className="font-medium">
            {detail.size.width.toFixed(1)}×{detail.size.height.toFixed(1)}"
          </span>
        </div>
        <div className="flex justify-between font-semibold text-gray-800 border-t pt-1">
          <span>Cost:</span>
          <span>₹{detail.cost}</span>

                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Total Cost */}
                <div className="bg-white rounded-lg p-4 border border-gray-200 mb-4">
                  <div className="flex justify-between items-center text-sm font-semibold">
                    <span>Total Cost:</span>
                    <span>
                      ₹{totalPrice} + {product.tax} + Shipping
                    </span>
                  </div>
                </div>

                {/* Selling Price */}
                <div className="mb-4">
                  <label htmlFor="sellingPriceMobile" className="block mb-2 font-medium text-sm">
                    Selling Price
                  </label>
                  <input
                    type="number"
                    id="sellingPriceMobile"
                    value={sellingPrice}
                    onChange={handleSellingPriceChange}
                    placeholder="Enter selling price"
                    required
                    className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 outline-none text-sm"
                  />
                  {errors.sellingPrice && (
                    <p className="text-red-500 text-xs mt-1">{errors.sellingPrice}</p>
                  )}
                </div>

              </div>
            </div>

            {/* Fixed Action Buttons at Bottom - Mobile Only */}
            <div className="lg:hidden mt-auto pt-4 border-t border-gray-200 bg-white">
              <div className="space-y-3">
                {!userShop ? (
                  <button
                    type="button"
                    disabled={isSubmitting}
                    onClick={handleSaveProduct}
                    className="w-full px-4 py-3 rounded-lg bg-black text-white hover:bg-gray-800 transition font-medium"
                  >
                    {isSubmitting ? "Saving Product..." : "Save Product"}
                  </button>
                ) : (
                  <>
                    <button
                      type="button"
                      disabled={isSubmitting}
                      onClick={() => handleSubmit("active")}
                      className="w-full px-4 py-3 rounded-lg bg-green-500/10 text-green-700 hover:bg-green-600 hover:text-white transition font-medium"
                    >
                      {isSubmitting ? "Submitting..." : <>Make It Live <FaShopify className="inline ml-1" /></>}
                    </button>
                    <button
                      type="button"
                      disabled={isSubmitting}
                      onClick={() => handleSubmit("draft")}
                      className="w-full px-4 py-3 rounded-lg bg-blue-500/10 text-blue-700 hover:bg-blue-600 hover:text-white transition font-medium"
                    >
                      {isSubmitting ? "Saving as Draft..." : <>Save as Draft <FaShopify className="inline ml-1" /></>}
                    </button>
                    <button
                      type="button"
                      disabled={isSubmitting}
                      onClick={handleSaveProduct}
                      className="w-full px-4 py-3 rounded-lg bg-black text-white hover:bg-gray-800 transition font-medium"
                    >
                      {isSubmitting ? "Saving Product..." : <>Save Product <FaSave className="inline ml-1" /></>}
                    </button>
                  </>
                )}
              </div>

              {userShop && (
                <div className="text-xs text-gray-500 mt-3 text-center">
                  *Do not change the SKU of the Shopify product after creation.
                </div>
              )}
            </div>

            {/* Modal */}
            {showModal && (
              <Modal>
                <div className="p-6 text-center space-y-4">
                  <h2 className="text-lg font-semibold">Your product has been created successfully!</h2>
                  <button
                    onClick={handleGoToProducts}
                    className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition"
                  >
                    Go to products page
                  </button>
                </div>
              </Modal>
            )}

            {/* Loader */}
            {isLoading && (
              <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999]">
                <div className="flex flex-col items-center">
                  <img src="Video1.GIF" alt="Loading..." className="w-24 h-auto" />
                  <div className="mt-2 text-white font-bold text-2xl">{progress}%</div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Middle Section - T-shirt Preview */}
        <div className="w-full lg:w-2/5 flex flex-col items-center">
          <div className="flex flex-wrap justify-center items-center gap-3 mb-4">
            <select
              onChange={(e) => setView(Number(e.target.value))}
              className="px-3 py-2 rounded-lg border border-gray-300 bg-white text-sm"
            >
              <option value="0">Front</option>
              <option value="1">Back</option>
              <option value="2">Left Sleeve</option>
              <option value="3">Right Sleeve</option>
              <option value="4">Left Hood</option>
              <option value="5">Right Hood</option>

            </select>

            <button
              onClick={() => setOpenDrawer(true)}
              className="lg:hidden px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-all duration-200 text-sm font-medium shadow-md hover:shadow-lg active:scale-95"
            >
              Customize
            </button>
            <button
              onClick={handleRotate}
              className="px-3 py-2 rounded-lg bg-blue-100 text-blue-700 hover:bg-blue-600 hover:text-white transition text-sm font-medium border border-blue-200"
            >
              <FaUndo />
            </button>
            <button
              onClick={handleDelete}
              className="px-3 py-2 rounded-lg bg-red-100 text-red-700 hover:bg-red-600 hover:text-white transition text-sm font-medium border border-red-200"
            >
              <FaTrash />
            </button>
          </div>

          {/* Canvases */}
          {[frontCanvasRef, backCanvasRef, leftSleeveCanvasRef, rightSleeveCanvasRef, leftHoodCanvasRef, rightHoodCanvasRef].map(
            (ref, index) => (
              <div key={index} style={{ display: view === index ? "block" : "none" }}>
                <div className="w-full max-w-[440px] h-[540px] overflow-hidden relative mx-auto touch-none flex justify-center items-start">
                  <div className="w-[440px] h-[540px] relative">
                    <canvas
                      ref={ref}
                      style={{
                        transform: "scale(0.2)",
                        transformOrigin: "top left",
                        position: "absolute",
                        top: 0,
                        left: 0,
                        touchAction: "none",
                        userSelect: "none",
                        WebkitUserSelect: "none",
                        MozUserSelect: "none",
                        msUserSelect: "none"
                      }}
                    />
                  </div>
                </div>
              </div>
            )
          )}
        </div>

        {/* Right Section - Print Details & Actions */}
        <div className="w-full lg:w-2/5 lg:max-w-[400px] shrink-0 hidden lg:block">
          <div className="bg-white rounded-lg p-4 h-full overflow-y-auto">
            <h3 className="text-lg font-semibold mb-4 text-center print-method-title">Print Details</h3>
            
            {/* Print Details Grid */}
            <div className="grid grid-cols-2 gap-3 text-xs mb-6">
              {[
                { title: "Front", type: selectedMethod.front, size: frontDesignSize, cost: frontDesignCost },
                { title: "Back", type: selectedMethod.back, size: backDesignSize, cost: backDesignCost },
                { title: "L Sleeve", type: selectedMethod.leftSleeve, size: leftSleeveDesignSize, cost: leftSleeveDesignCost },
                { title: "R Sleeve", type: selectedMethod.rightSleeve, size: rightSleeveDesignSize, cost: rightSleeveDesignCost },
                 { title: "L Hood", type: selectedMethod.leftHood, size: leftHoodDesignSize, cost: leftHoodDesignCost },
                { title: "R Hood", type: selectedMethod.rightHood, size: rightHoodDesignSize, cost: rightHoodDesignCost },
              ].map((detail) => (
                <div key={detail.title} className="p-3 border border-gray-200 rounded-md bg-white shadow-sm">
                  <h4 className="font-medium text-gray-800 mb-2 text-center">{detail.title}</h4>
                  <div className="space-y-1">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Type:</span>
                      <span className="font-medium">{detail.type || "-"}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Size:</span>
                      <span className="font-medium">
                        {detail.size.width.toFixed(1)}×{detail.size.height.toFixed(1)}"
                      </span>
                    </div>
                    <div className="flex justify-between font-semibold text-gray-800 border-t pt-1">
                      <span>Cost:</span>
                      <span>₹{detail.cost}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Total Cost */}
            <div className="bg-white rounded-lg p-4 border border-gray-200 mb-4">
              <div className="flex justify-between items-center text-sm font-semibold">
                <span>Total Cost:</span>
                <span>
                  ₹{totalPrice} + {product.tax} + Shipping
                </span>
              </div>
            </div>

            {/* Selling Price */}
            <div className="mb-4">
              <label htmlFor="sellingPrice" className="block mb-2 font-medium text-sm">
                Selling Price
              </label>
              <input
                type="number"
                id="sellingPrice"
                value={sellingPrice}
                onChange={handleSellingPriceChange}
                placeholder="Enter selling price"
                required
                className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 outline-none text-sm"
              />
              {errors.sellingPrice && (
                <p className="text-red-500 text-xs mt-1">{errors.sellingPrice}</p>
              )}
            </div>

            {/* Action Buttons */}
            <div className="space-y-3">
              {!userShop ? (
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={handleSaveProduct}
                  className="w-full px-4 py-3 rounded-lg bg-black text-white hover:bg-gray-800 transition font-medium"
                >
                  {isSubmitting ? "Saving Product..." : "Save Product"}
                </button>
              ) : (
                <>
                  <button
                    type="button"
                    disabled={isSubmitting}
                    onClick={() => handleSubmit("active")}
                    className="w-full px-4 py-3 rounded-lg bg-green-500/10 text-green-700 hover:bg-green-600 hover:text-white transition font-medium"
                  >
                    {isSubmitting ? "Submitting..." : <>Make It Live <FaShopify className="inline ml-1" /></>}
                  </button>
                  <button
                    type="button"
                    disabled={isSubmitting}
                    onClick={() => handleSubmit("draft")}
                    className="w-full px-4 py-3 rounded-lg bg-blue-500/10 text-blue-700 hover:bg-blue-600 hover:text-white transition font-medium"
                  >
                    {isSubmitting ? "Saving as Draft..." : <>Save as Draft <FaShopify className="inline ml-1" /></>}
                  </button>
                  <button
                    type="button"
                    disabled={isSubmitting}
                    onClick={handleSaveProduct}
                    className="w-full px-4 py-3 rounded-lg bg-black text-white hover:bg-gray-800 transition font-medium"
                  >
                    {isSubmitting ? "Saving Product..." : <>Save Product <FaSave className="inline ml-1" /></>}
                  </button>
                </>
              )}
            </div>

            {userShop && (
              <div className="text-xs text-gray-500 mt-3 text-center">
                *Do not change the SKU of the Shopify product after creation.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

};
export default HoodiesDesign;
